//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../MBD/MBD.SemanticTopologyBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Application",1,0],[0,"GroupName",1,0],[0,"Itemize",1,0],[0,"Label",1,0],[0,"LabelGroup",1,0],[0,"Method",1,0],[0,"ReferenceObject",1,0],[1,"SelectedObjects",0,"SelectNXObjectList",0],[1,"SelectedPMIs",0,"SelectNXObjectList",0],[1,"SelectedSemanticObjects",0,"SelectNXObjectList",0],[1,"TopologyBuilder",0,"MBD.SemanticTopologyBuilder",0],[0,"TopologyType",1,0],[0,"Value",1,0]],[[["nDescription"],"GetDescription",{R_:{description:""}},0,0],[["description"],"SetDescription",{},1,0],[[],"CreateAttribute",{},0,0],[[],"RemoveAttribute",{},0,0]],[]];
SPLM.MBD.SemanticDataBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.SemanticDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.SemanticDataBuilder.IdentifierMethod = Object.freeze({
    "AutomaticStructured" : "AutomaticStructured", "AutomaticRandom" : "AutomaticRandom", "UserSpecified" : "UserSpecified"});

export default SPLM;